// contexts/PortfolioContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { defaultPortfolio } from '../data/default-portfolio';

const PortfolioContext = createContext<any>(null);

export const PortfolioProvider = ({ children }: { children: React.ReactNode }) => {
  console.log(`Fetching portfolio data`);
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error] = useState<string | null>(null);

  useEffect(() => {
    // Using local default data (BE not deployed)
    setData(defaultPortfolio);
    setLoading(false);
    // Uncomment below to fetch from BE when it's available
    // const serviceCaller = new ServiceCaller();
    // serviceCaller.getPortfolioData()
    //   .then((res) => {
    //     console.log(`Fetched data - ${JSON.stringify(res[0])}`)
    //     setData(res[0]);
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     console.error(`Error fetching portfolio data: ${err}`);
    //     setData(defaultPortfolio);
    //     setLoading(false);
    //   });
  }, []);

  return (
    <PortfolioContext.Provider value={{ data, loading, error }}>
      {children}
    </PortfolioContext.Provider>
  );
};

export const usePortfolio = () => useContext(PortfolioContext);